import { makeCommandFromAttributes } from '../../utils/index.js';
export var TransitionProfile;
(function (TransitionProfile) {
    TransitionProfile[TransitionProfile["IMMEDIATE"] = 0] = "IMMEDIATE";
    TransitionProfile[TransitionProfile["FAST"] = 1] = "FAST";
    TransitionProfile[TransitionProfile["MEDIUM"] = 2] = "MEDIUM";
    TransitionProfile[TransitionProfile["SLOW"] = 3] = "SLOW";
    TransitionProfile[TransitionProfile["BOUNCE"] = 4] = "BOUNCE";
})(TransitionProfile || (TransitionProfile = {}));
const defineServoTurnoutCommandKey = 'T';
/**
 * https://dcc-ex.com/reference/software/command-reference.html#defining-setting-up-a-turnout
 */
export const defineServoTurnoutCommand = ({ turnout, pin, thrownPosition, closedPosition, profile }) => {
    const constant = 'SERVO';
    const attributes = [
        defineServoTurnoutCommandKey,
        turnout,
        constant,
        pin,
        thrownPosition,
        closedPosition,
        profile
    ];
    return makeCommandFromAttributes(attributes);
};
